import { render, staticRenderFns } from "./DeliveriesTable.vue?vue&type=template&id=1c023c96&"
import script from "./DeliveriesTable.vue?vue&type=script&lang=js&"
export * from "./DeliveriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports